import { render } from "./LocalProducts.vue?vue&type=template&id=1e227c18&scoped=true&ts=true"
import script from "./LocalProducts.vue?vue&type=script&lang=ts"
export * from "./LocalProducts.vue?vue&type=script&lang=ts"

import "./LocalProducts.vue?vue&type=style&index=0&id=1e227c18&scoped=true&lang=css"
import "./LocalProducts.vue?vue&type=style&index=1&id=1e227c18&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e227c18"]])

export default __exports__